import {
  archiveCatalogApi,
  createCatalogApi,
  listCatalogApi,
  updateCatalogApi,
} from './apiClient'
import type { AttributeKind, CatalogInput, CatalogItem } from './types'

/**
 * Catalog → Postgres API (Phase 3b Step 6b).
 * remove() = soft archive (is_active=false) — matches CatalogPage confirm copy.
 */
export const catalogService = {
  list(kind: AttributeKind, includeInactive = false): Promise<CatalogItem[]> {
    return listCatalogApi(kind, includeInactive)
  },
  create(kind: AttributeKind, input: CatalogInput): Promise<CatalogItem> {
    return createCatalogApi(kind, input)
  },
  update(
    kind: AttributeKind,
    id: string,
    input: Partial<CatalogInput>,
  ): Promise<CatalogItem> {
    return updateCatalogApi(kind, id, input)
  },
  async remove(kind: AttributeKind, id: string): Promise<void> {
    await archiveCatalogApi(kind, id)
  },
}

export type { AttributeKind, CatalogInput, CatalogItem, CatalogSopFile } from './types'
export { ATTRIBUTE_KIND_LABEL, COLOR_TYPE_OPTIONS } from './types'
export {
  getCatalogMetadata,
  saveCatalogMetadata,
  enrichCatalogItem,
} from './catalogMetadataStorage'
export {
  findCatalogIdByName,
  resolveCatalogItems,
} from './mockRepository'
export {
  catalogApiDtoToUi,
  CatalogApiClientError,
  createCatalogApi,
  createColorApi,
  createVeneerApi,
  createWoodTypeApi,
  listCatalogApi,
  listColorsApi,
  listVeneersApi,
  listWoodTypesApi,
  updateCatalogApi,
  updateColorApi,
  updateVeneerApi,
  updateWoodTypeApi,
} from './apiClient'
